export enum ActionTypes {
  FETCH_STREAMER = 'FETCH_STREAMER',
  FETCH_PARTNER = 'FETCH_PARTNER',
  SET_LOCALE = 'SET_LOCALE',
}
